// GENERATED — do not edit by hand.
// Snapshot of the live board at onepiecetrivia.com/api/leaderboard.
// Refresh with: node scripts/refresh-onepiece-leaderboard.js
export const onePieceBoard = {
  "capturedAt": "2026-10-21T23:22:18.392Z",
  "totals": {
    "plays": 266,
    "registeredPlayers": 70,
    "rankedPlayers": 61,
    "activePlayers30d": 18,
    "activeShare": 30,
    "plays30d": 61,
    "plays7d": 29,
    "recentShare": 23,
    "perfectRounds": 118,
    "accuracy": 90.4,
    "firstPlay": "2026-04-25T06:51:43.946Z",
    "latestPlay": "2026-10-21T06:14:50.232Z"
  },
  "games": [
    {
      "id": "character",
      "label": "Character",
      "emoji": "🏴‍☠️",
      "maxScore": 15,
      "plays": 84,
      "top": [
        {
          "rank": 1,
          "username": "Truc______",
          "avatar": "https://cdn.myanimelist.net/images/characters/3/100534.jpg",
          "score": 15,
          "totalTime": 27,
          "date": "2026-09-03T19:45:01.418Z"
        },
        {
          "rank": 2,
          "username": "MONKEYDLUFFY",
          "avatar": "https://cdn.myanimelist.net/images/characters/9/310307.jpg",
          "score": 15,
          "totalTime": 30,
          "date": "2026-08-29T01:19:04.068Z"
        },
        {
          "rank": 3,
          "username": "H0II0W_NUK3",
          "avatar": "https://cdn.myanimelist.net/images/characters/9/307639.jpg",
          "score": 15,
          "totalTime": 31,
          "date": "2026-08-18T03:28:36.771Z"
        },
        {
          "rank": 4,
          "username": "The_Honored_one",
          "avatar": "🏴‍☠️",
          "score": 15,
          "totalTime": 33,
          "date": "2026-08-18T02:43:42.859Z"
        },
        {
          "rank": 5,
          "username": "The_H0nored_One",
          "avatar": "https://cdn.myanimelist.net/images/characters/10/258757.jpg",
          "score": 15,
          "totalTime": 33,
          "date": "2026-08-18T03:06:06.935Z"
        },
        {
          "rank": 6,
          "username": "brayzionist",
          "avatar": "💀",
          "score": 15,
          "totalTime": 33,
          "date": "2026-08-24T18:19:07.078Z"
        },
        {
          "rank": 7,
          "username": "brayzionist",
          "avatar": "💀",
          "score": 15,
          "totalTime": 35,
          "date": "2026-08-17T18:43:56.082Z"
        },
        {
          "rank": 8,
          "username": "brayzionist",
          "avatar": "💀",
          "score": 15,
          "totalTime": 37,
          "date": "2026-08-24T18:15:33.754Z"
        },
        {
          "rank": 9,
          "username": "MONKEYDLUFFY",
          "avatar": "https://cdn.myanimelist.net/images/characters/9/310307.jpg",
          "score": 15,
          "totalTime": 37,
          "date": "2026-08-29T01:20:05.991Z"
        },
        {
          "rank": 10,
          "username": "MONKEYDLUFFY",
          "avatar": "https://cdn.myanimelist.net/images/characters/9/310307.jpg",
          "score": 15,
          "totalTime": 38,
          "date": "2026-08-29T01:17:46.917Z"
        }
      ]
    },
    {
      "id": "image",
      "label": "Image",
      "emoji": "🖼️",
      "maxScore": 15,
      "plays": 52,
      "top": [
        {
          "rank": 1,
          "username": "H0II0W_NUK3",
          "avatar": "https://cdn.myanimelist.net/images/characters/9/307639.jpg",
          "score": 15,
          "totalTime": 23,
          "date": "2026-08-18T03:36:13.375Z"
        },
        {
          "rank": 2,
          "username": "Truc______",
          "avatar": "https://cdn.myanimelist.net/images/characters/3/100534.jpg",
          "score": 15,
          "totalTime": 26,
          "date": "2026-09-03T19:54:18.311Z"
        },
        {
          "rank": 3,
          "username": "Truc______",
          "avatar": "https://cdn.myanimelist.net/images/characters/3/100534.jpg",
          "score": 15,
          "totalTime": 29,
          "date": "2026-09-03T19:43:28.709Z"
        },
        {
          "rank": 4,
          "username": "MONKEYDLUFFY",
          "avatar": "https://cdn.myanimelist.net/images/characters/9/310307.jpg",
          "score": 15,
          "totalTime": 32,
          "date": "2026-08-29T01:21:37.625Z"
        },
        {
          "rank": 5,
          "username": "The_H0nored_One",
          "avatar": "https://cdn.myanimelist.net/images/characters/10/258757.jpg",
          "score": 15,
          "totalTime": 36,
          "date": "2026-08-18T03:08:35.783Z"
        },
        {
          "rank": 6,
          "username": "Yoru",
          "avatar": "https://cdn.myanimelist.net/images/characters/7/69747.jpg",
          "score": 15,
          "totalTime": 37,
          "date": "2026-10-16T00:22:30.272Z"
        },
        {
          "rank": 7,
          "username": "brayzionist",
          "avatar": "🏴‍☠️",
          "score": 15,
          "totalTime": 43,
          "date": "2026-08-17T18:33:39.850Z"
        },
        {
          "rank": 8,
          "username": "Goku_17",
          "avatar": "🏴‍☠️",
          "score": 15,
          "totalTime": 44,
          "date": "2026-10-12T17:02:25.821Z"
        },
        {
          "rank": 9,
          "username": "Joshbutt",
          "avatar": "🏴‍☠️",
          "score": 15,
          "totalTime": 44,
          "date": "2026-10-16T23:32:53.924Z"
        },
        {
          "rank": 10,
          "username": "Haru5596",
          "avatar": "🏴‍☠️",
          "score": 15,
          "totalTime": 45,
          "date": "2026-08-24T01:03:49.792Z"
        }
      ]
    },
    {
      "id": "devilfruit",
      "label": "Devil Fruit",
      "emoji": "🍎",
      "maxScore": 15,
      "plays": 61,
      "top": [
        {
          "rank": 1,
          "username": "Truc______",
          "avatar": "https://cdn.myanimelist.net/images/characters/3/100534.jpg",
          "score": 15,
          "totalTime": 21,
          "date": "2026-09-03T19:26:39.973Z"
        },
        {
          "rank": 2,
          "username": "idk",
          "avatar": "🏴‍☠️",
          "score": 15,
          "totalTime": 24,
          "date": "2026-09-03T19:23:10.100Z"
        },
        {
          "rank": 3,
          "username": "Truc______",
          "avatar": "https://cdn.myanimelist.net/images/characters/3/100534.jpg",
          "score": 15,
          "totalTime": 24,
          "date": "2026-09-03T19:55:21.459Z"
        },
        {
          "rank": 4,
          "username": "H0II0W_NUK3",
          "avatar": "https://cdn.myanimelist.net/images/characters/9/307639.jpg",
          "score": 15,
          "totalTime": 25,
          "date": "2026-08-18T03:37:12.158Z"
        },
        {
          "rank": 5,
          "username": "Truc______",
          "avatar": "https://cdn.myanimelist.net/images/characters/3/100534.jpg",
          "score": 15,
          "totalTime": 25,
          "date": "2026-09-03T19:25:52.794Z"
        },
        {
          "rank": 6,
          "username": "brayzionist",
          "avatar": "🏴‍☠️",
          "score": 15,
          "totalTime": 27,
          "date": "2026-08-17T18:26:35.597Z"
        },
        {
          "rank": 7,
          "username": "The_H0nored_One",
          "avatar": "https://cdn.myanimelist.net/images/characters/10/258757.jpg",
          "score": 15,
          "totalTime": 27,
          "date": "2026-08-18T03:13:46.843Z"
        },
        {
          "rank": 8,
          "username": "zorocutavk",
          "avatar": "🗡️",
          "score": 15,
          "totalTime": 28,
          "date": "2026-06-03T17:37:03.728Z"
        },
        {
          "rank": 9,
          "username": "zorocutavk",
          "avatar": "🗡️",
          "score": 15,
          "totalTime": 33,
          "date": "2026-06-03T17:36:14.628Z"
        },
        {
          "rank": 10,
          "username": "zorocutavk",
          "avatar": "🗡️",
          "score": 15,
          "totalTime": 33,
          "date": "2026-06-03T17:41:38.444Z"
        }
      ]
    },
    {
      "id": "bounty",
      "label": "Bounty Battle",
      "emoji": "💰",
      "maxScore": 11,
      "plays": 69,
      "top": [
        {
          "rank": 1,
          "username": "Truc______",
          "avatar": "https://cdn.myanimelist.net/images/characters/3/100534.jpg",
          "score": 11,
          "totalTime": 14,
          "date": "2026-09-03T19:52:47.282Z"
        },
        {
          "rank": 2,
          "username": "larp",
          "avatar": "🏴‍☠️",
          "score": 11,
          "totalTime": 18,
          "date": "2026-10-19T09:38:51.990Z"
        },
        {
          "rank": 3,
          "username": "H0II0W_NUK3",
          "avatar": "https://cdn.myanimelist.net/images/characters/9/307639.jpg",
          "score": 11,
          "totalTime": 19,
          "date": "2026-08-18T12:32:11.999Z"
        },
        {
          "rank": 4,
          "username": "MrShaikh",
          "avatar": "🏴‍☠️",
          "score": 11,
          "totalTime": 19,
          "date": "2026-10-11T16:50:15.260Z"
        },
        {
          "rank": 5,
          "username": "The_Honored_one",
          "avatar": "https://cdn.myanimelist.net/images/characters/10/258757.jpg",
          "score": 11,
          "totalTime": 20,
          "date": "2026-08-18T02:57:19.886Z"
        },
        {
          "rank": 6,
          "username": "brayzionist",
          "avatar": "🏴‍☠️",
          "score": 11,
          "totalTime": 22,
          "date": "2026-08-17T18:31:50.392Z"
        },
        {
          "rank": 7,
          "username": "The_H0nored_One",
          "avatar": "https://cdn.myanimelist.net/images/characters/10/258757.jpg",
          "score": 11,
          "totalTime": 23,
          "date": "2026-08-18T03:23:16.113Z"
        },
        {
          "rank": 8,
          "username": "MONKEYDLUFFY",
          "avatar": "https://cdn.myanimelist.net/images/characters/9/310307.jpg",
          "score": 11,
          "totalTime": 23,
          "date": "2026-08-29T01:27:01.663Z"
        },
        {
          "rank": 9,
          "username": "MonkeyDLuk",
          "avatar": "https://cdn.myanimelist.net/images/characters/10/258757.jpg",
          "score": 11,
          "totalTime": 26,
          "date": "2026-07-06T21:40:13.486Z"
        },
        {
          "rank": 10,
          "username": "Usoland",
          "avatar": "🏴‍☠️",
          "score": 11,
          "totalTime": 29,
          "date": "2026-10-08T00:32:47.542Z"
        }
      ]
    }
  ],
  "grandMasters": [
    {
      "username": "Truc______",
      "avatar": "https://cdn.myanimelist.net/images/characters/3/100534.jpg",
      "total": 56,
      "totalTime": 88,
      "scores": {
        "character": 15,
        "image": 15,
        "devilfruit": 15,
        "bounty": 11
      }
    },
    {
      "username": "H0II0W_NUK3",
      "avatar": "https://cdn.myanimelist.net/images/characters/9/307639.jpg",
      "total": 56,
      "totalTime": 98,
      "scores": {
        "character": 15,
        "image": 15,
        "devilfruit": 15,
        "bounty": 11
      }
    },
    {
      "username": "The_H0nored_One",
      "avatar": "https://cdn.myanimelist.net/images/characters/10/258757.jpg",
      "total": 56,
      "totalTime": 119,
      "scores": {
        "character": 15,
        "image": 15,
        "devilfruit": 15,
        "bounty": 11
      }
    },
    {
      "username": "MONKEYDLUFFY",
      "avatar": "https://cdn.myanimelist.net/images/characters/9/310307.jpg",
      "total": 56,
      "totalTime": 119,
      "scores": {
        "character": 15,
        "image": 15,
        "devilfruit": 15,
        "bounty": 11
      }
    },
    {
      "username": "brayzionist",
      "avatar": "🏴‍☠️",
      "total": 56,
      "totalTime": 125,
      "scores": {
        "character": 15,
        "image": 15,
        "devilfruit": 15,
        "bounty": 11
      }
    },
    {
      "username": "Haru5596",
      "avatar": "🏴‍☠️",
      "total": 56,
      "totalTime": 187,
      "scores": {
        "character": 15,
        "image": 15,
        "devilfruit": 15,
        "bounty": 11
      }
    },
    {
      "username": "Yoru",
      "avatar": "🏴‍☠️",
      "total": 55,
      "totalTime": 160,
      "scores": {
        "character": 14,
        "image": 15,
        "devilfruit": 15,
        "bounty": 11
      }
    },
    {
      "username": "ppppp",
      "avatar": "🏴‍☠️",
      "total": 55,
      "totalTime": 198,
      "scores": {
        "character": 14,
        "image": 15,
        "devilfruit": 15,
        "bounty": 11
      }
    },
    {
      "username": "The_Honored_one",
      "avatar": "🏴‍☠️",
      "total": 54,
      "totalTime": 125,
      "scores": {
        "character": 15,
        "image": 13,
        "devilfruit": 15,
        "bounty": 11
      }
    },
    {
      "username": "bartyFan",
      "avatar": "🏴‍☠️",
      "total": 53,
      "totalTime": 300,
      "scores": {
        "character": 14,
        "image": 13,
        "devilfruit": 15,
        "bounty": 11
      }
    }
  ],
  "regulars": [
    {
      "username": "brayzionist",
      "avatar": "🏴‍☠️",
      "plays": 19,
      "best": 15
    },
    {
      "username": "Truc______",
      "avatar": "https://cdn.myanimelist.net/images/characters/3/100534.jpg",
      "plays": 19,
      "best": 15
    },
    {
      "username": "The_Honored_one",
      "avatar": "🏴‍☠️",
      "plays": 16,
      "best": 15
    },
    {
      "username": "zorocutavk",
      "avatar": "🗡️",
      "plays": 11,
      "best": 15
    },
    {
      "username": "bartyFan",
      "avatar": "🏴‍☠️",
      "plays": 11,
      "best": 15
    },
    {
      "username": "ppppp",
      "avatar": "🏴‍☠️",
      "plays": 9,
      "best": 15
    },
    {
      "username": "The_H0nored_One",
      "avatar": "https://cdn.myanimelist.net/images/characters/10/258757.jpg",
      "plays": 9,
      "best": 15
    },
    {
      "username": "MONKEYDLUFFY",
      "avatar": "https://cdn.myanimelist.net/images/characters/9/310307.jpg",
      "plays": 9,
      "best": 15
    }
  ],
  "monthly": [
    {
      "month": "2026-04",
      "plays": 1
    },
    {
      "month": "2026-05",
      "plays": 16
    },
    {
      "month": "2026-06",
      "plays": 19
    },
    {
      "month": "2026-07",
      "plays": 18
    },
    {
      "month": "2026-08",
      "plays": 89
    },
    {
      "month": "2026-09",
      "plays": 62
    },
    {
      "month": "2026-10",
      "plays": 61
    }
  ]
};
